/**
 * Custom comparator for React.memo on React Flow node components.
 *
 * React Flow passes many props that change on every frame during drag/pan
 * (positionAbsoluteX/Y, dragging, zIndex, …). The default shallow compare
 * treats those as "changed" and forces a re-render of every visible node.
 *
 * This comparator only compares `id`, `type`, and does a shallow-equal on
 * `data` — the only fields that actually affect node *content* rendering.
 * Selection / internal state is handled by hooks (useInternalNode, useStore)
 * inside each component, so we can safely ignore it here.
 */
export function areNodePropsEqual(prev: any, next: any): boolean {
  if (prev.id !== next.id || prev.type !== next.type) return false;

  const pd = prev.data;
  const nd = next.data;
  if (pd === nd) return true;
  if (!pd || !nd) return pd === nd;

  const pKeys = Object.keys(pd);
  const nKeys = Object.keys(nd);
  if (pKeys.length !== nKeys.length) return false;
  for (const k of nKeys) {
    if (!Object.is(pd[k], nd[k])) return false;
  }
  return true;
}
